import { baseUrl, useAxios } from "services/rest/request";

export function useMakePayment(invoiceId: string) {
  return useAxios({
    url: `${baseUrl}/invoices/${invoiceId}/pay`,
    method: "post",
  }, [], false);
}